import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const tipoAreaService = {
  guardarTipoArea,
  getTipoArea,
}

async function getTipoArea() {
  return await ApiBudgety.get('TipoArea/GetAll')
}

async function guardarTipoArea(tipoArea) {
  return await ApiBudgety.post('TipoArea/InsertOrUpdate/', tipoArea, {
    headers: {
      ACCION: MenusSistema.mantenedor_area.accesos.crear_editar_tipo_area,
      MENU: MenusSistema.mantenedor_area.id,
    },
  })
}
